import { Link, styled } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';

export const UploadedFileListItemText = styled('p')({
	margin: 0,
	maxWidth: '40%',
	overflow: 'hidden',
	whiteSpace: 'nowrap',
	textOverflow: 'ellipsis',
});

export const UploadedFileListItemLink = styled(Link)({
	display: 'block',
	overflow: 'hidden',
	whiteSpace: 'nowrap',
	textOverflow: 'ellipsis',
});

export const UploadedFileListItemWrap = styled('li')({
	display: 'flex',
	alignItems: 'center',
});

export const UploadedFileListItemDeleteIcon = styled(DeleteIcon, {
	shouldForwardProp: (prop) => prop !== 'isError',
})(({ isError }: { isError: boolean }) => ({
	...(isError && { color: '#FF0000' }),
	fontSize: '18px',
}));
